import { ConfidenceTypes, ReviewSourceTypes } from ".";
import { VendorRiskResponseItemForVendorOverview } from "./vendorOverviewSection";
import { VendorRiskResponseItemForPotentialIssues } from "./vendorPotentialIssues";
import { VendorRiskResponseItemForSecurityAssessment } from "./vendorSecurityAssessment";
import { VendorRiskResponseItemForVendorSupplyChain } from "./vendorSupplyChain";

export enum VendorRiskSectionEnum {
  vendor_overview = "vendor_overview",
  vendor_supply_chain = "vendor_supply_chain",
  potential_issues = "potential_issues",
  zania_security_assessment = "zania_security_assessment",
  ai_security_assessment = "ai_security_assessment",
  company_profile = "company_profile",
}

export type VendorRiskResponseMappedBySection = {
  [VendorRiskSectionEnum.vendor_overview]: VendorRiskResponseItemForVendorOverview[];
  [VendorRiskSectionEnum.vendor_supply_chain]: VendorRiskResponseItemForVendorSupplyChain[];
  [VendorRiskSectionEnum.potential_issues]: VendorRiskResponseItemForPotentialIssues[];
  [VendorRiskSectionEnum.zania_security_assessment]: VendorRiskResponseItemForSecurityAssessment[];
  [VendorRiskSectionEnum.ai_security_assessment]: VendorRiskResponseItemForSecurityAssessment[];
  [VendorRiskSectionEnum.company_profile]: VendorRiskResponseItemForVendorSupplyChain[];
};

export type VendorRiskResponseItem =
  | VendorRiskResponseItemForSecurityAssessment
  | VendorRiskResponseItemForVendorOverview
  | VendorRiskResponseItemForVendorSupplyChain
  | VendorRiskResponseItemForPotentialIssues;

export interface BaseLLMResponse {
  confidence: ConfidenceTypes;
  sources: ReviewSourceTypes[];
}
